import type { TermKind, TermSummary } from "../rdf/types";

export type ExplorerTab = "classes" | "properties" | "ontologies" | "files";

export const EXPLORER_TABS: Array<{ id: ExplorerTab; label: string }> = [
  { id: "classes", label: "Classes" },
  { id: "properties", label: "Properties" },
  { id: "ontologies", label: "Ontologies" },
  { id: "files", label: "Files" },
];

/** Which Explorer tab a term's tree/list naturally belongs to, for search results and cross-navigation. */
export function tabForKind(kind: TermKind): ExplorerTab {
  switch (kind) {
    case "ObjectProperty":
    case "DatatypeProperty":
    case "AnnotationProperty":
    case "Property":
      return "properties";
    case "Ontology":
      return "ontologies";
    default:
      return "classes";
  }
}

export function explorePath(term: TermSummary): string {
  return `/explore/${tabForKind(term.kind)}?term=${encodeURIComponent(term.iri)}`;
}

export function visualizePath(iri: string): string {
  return `/visualize?focus=${encodeURIComponent(iri)}`;
}
